import React, { ReactText } from 'react';

export interface IProps {
  authKey: string | number | ReactText[] | ((auth: ReactText[]) => boolean);
}

let globalAuthStore: {
  menuAuth?: ReactText[]; // 菜单权限
  funcAuth?: ReactText[]; // 功能权限
};

export enum ResourceType {
  PAGE = 1,
  FUNCTION = 2,
  DATA = 3,
  DATARANGE = 4,
  DEPART = 5,
  MENU = 6,
}

export const getGlobalAuthStore = () => {
  return globalAuthStore;
};

export const setGlobalAuthStore = (authStore: Partial<typeof globalAuthStore>) => {
  globalAuthStore = authStore;
};

// 功能权限
export const Auth: React.FC<IProps> = props => {
  const { children, authKey } = props;
  const authStore = getGlobalAuthStore();
  let hasAuth = false;
  if (typeof authKey === 'function') {
    hasAuth = authKey(authStore?.funcAuth);
  } else {
    const authKeys: ReactText[] = Array.isArray(authKey) ? authKey : [authKey];
    hasAuth = authKeys.some(item => authStore?.funcAuth?.includes(item));
  }
  if (!hasAuth) {
    return null;
  }
  return <>{children}</>;
};
